import React from 'react';
import Draggable from 'react-draggable';
import {Panel, Glyphicon} from 'react-bootstrap/lib';
import { isMobile } from 'react-device-detect';

const backgroundBlue = {
  backgroundColor: '#ccf2ff',
};

export default class Drag extends React.Component {
  //Wraps components in a popup draggable window

  render() {
    const { help } = this.props;
    //TODO consider making this a <Panel/> header if we want to style it as such
    let header = this.props.headerText ? <span className="header">{this.props.headerText}</span> : null;
    return (
      <Draggable defaultPosition={isMobile ? {x: 43, y: 0} : {x: 0, y: 0}}>
        <div className={"dragPopup"}>
          <Panel className={this.props.className} style={help ? backgroundBlue : {}}>
            {header}
            <Glyphicon className="closeButton" glyph='remove-circle' onClick={this.props.close} />
            <div className="dragContent">
              {this.props.children}
            </div>
          </Panel>
        </div>
      </Draggable>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Common/Drag.js